import { render, staticRenderFns } from "./minimal-experience.vue?vue&type=template&id=aef53224&scoped=true"
import script from "./minimal-experience.vue?vue&type=script&lang=js"
export * from "./minimal-experience.vue?vue&type=script&lang=js"
import style0 from "./minimal-experience.vue?vue&type=style&index=0&id=aef53224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef53224",
  null
  
)

export default component.exports